import React, { Component } from 'react'
import PT from 'prop-types'
import { Link } from 'react-router-dom'
import Recaptcha from 'react-recaptcha'
import { Form, Button, Input, Card, Radio, Checkbox } from 'element-react'
import debounce from 'lodash.debounce'
import Uploader from '../Uploader'
import validation from './validation'
import { imagesProp } from '../../propTypes'
import './Form.css'

const { Item } = Form

class UploadForm extends Component {
  constructor(props) {
    super(props)
    this.debouncedSave = debounce(this.handleSaveFormData, 1000)
    this.state = {
      form: {
        email: '',
        name: '',
        content: '',
        youtube: '',
        gdpr: false,
      },
      type: 'Len text',
      isAudioOverLimit: false,
      isImageOverLimit: false,
      overLimitFileSize: 0,
      notValid: false,
      wasSubmitAttempted: false,
      isUploading: false,
    }

    if (localStorage) {
      const data = JSON.parse(localStorage.getItem('spytajsavasich'))
      if (!data) return

      Object.keys(data).forEach((key) => {
        this.state.form[key] = data[key]
      })
    }
  }

  handleChange = name => (value) => {
    this.setState({
      form: {
        ...this.state.form,
        [name]: value,
      },
    })

    // save localstorage
    this.debouncedSave(name, value)
  }

  handleSaveFormData = () => {
    if (!localStorage) return
    const { name, email, content } = this.state.form

    const newData = JSON.stringify({
      name,
      email,
      content,
    })
    localStorage.setItem('spytajsavasich', newData)
  }

  handleSubmit = () => {
    this.setState({ wasSubmitAttempted: true })

    this.form.validate((valid) => {
      if (valid) {
        this.executeRecaptcha()
        return true
      }

      this.checkBottomError()

      return false
    })
    return true
  }

  checkBottomError() {
    // show up in form errors only if accept rules checked
    this.setState({ notValid: true })
    this.form.validateField('gdpr', (errMsg) => {
      this.setState({ notValid: !errMsg })
    })
  }

  handleFieldBlur = () => {
    if (!this.state.wasSubmitAttempted) return

    this.form.validate((valid) => {
      if (!valid) {
        this.checkBottomError()
        return false
      }
      this.setState({ notValid: false })
      return true
    })
  }

  handleRef = (ref) => {
    this.form = ref
  }

  handleRadioChange = (type) => {
    this.setState({ type })
  }

  handleFileSizeLimit = (size, isAudio) => {
    const key = isAudio ? 'isAudioOverLimit' : 'isImageOverLimit'
    this.setState({
      [key]: true,
      overLimitFileSize: Math.round(size / 1000000),
    })
  }

  handleFileRemove = () => {
    this.setState({
      isAudioOverLimit: false,
      isImageOverLimit: false,
    })
  }

  handleRecaptchaRef = (ref) => {
    this.recaptcha = ref
  }

  executeRecaptcha = () => {
    this.props.onSubmitStart()
    this.recaptcha.execute()
  }

  handleRecaptchaResponse = (recaptchaResponse) => {
    if (!recaptchaResponse) {
      if (window.Raven) {
        window.Raven.captureException(new Error('recaptcha response empty'))
      }
      this.props.onError()
      return
    }
    this.props.onSubmit(this.state.form, recaptchaResponse)
  }

  handleFileUploadStart = () => {
    this.setState({ isUploading: true })
  }

  handleFilesUploadFinished = () => {
    this.setState({ isUploading: false })
  }

  // eslint-disable-next-line
  componentDidCatch(error, info) {
    if (window.Raven) {
      window.Raven.captureException(error, { extra: info })
    }
  }

  render() {
    const {
      type, isAudioOverLimit, isImageOverLimit, overLimitFileSize,
    } = this.state

    return (
      <Form
        ref={this.handleRef}
        rules={validation}
        className="SubmitPostForm"
        model={this.state.form}
      >
        <Card>

          <Item label="Meno" prop="name">
            <Input placeholder="Vaše meno" value={this.state.form.name} onChange={this.handleChange('name')} onBlur={this.handleFieldBlur} />
          </Item>
          <Item label="Email" prop="email">
            <Input placeholder="Váš email" value={this.state.form.email} onChange={this.handleChange('email')} onBlur={this.handleFieldBlur} />
          </Item>
          <Item label="Text" prop="content">
            <Input
              type="textarea"
              placeholder="Napíšte váš príbeh, alebo popis k priloženému videu, fotografii, alebo audionahrávke. Kto to je, kde to je, kedy to bolo…"
              value={this.state.form.content}
              onChange={this.handleChange('content')}
              autosize={{ minRows: 10, maxRows: 30 }}
              onBlur={this.handleFieldBlur}
            />
          </Item>

          <div className="attachment">
            <h2>Chcem pridať:</h2>
            <Radio.Group value={type} onChange={this.handleRadioChange}>
              <Radio.Button value="Len text" />
              <Radio.Button value="Fotografie" />
              <Radio.Button value="Video" />
              <Radio.Button value="Zvuk" />
            </Radio.Group>

            {type === 'Video' && (
              <div className="video">
                <Item label="YouTube link" prop="youtube">
                  <Input placeholder="https://www.youtube.com/watch?v=XvOFEtqyEJQ" value={this.state.form.youtube} onChange={this.handleChange('youtube')} />
                </Item>
                <p>
                  <span>Pre vloženie videa, je potrebné ho najprv nahrať na youtube.com a následne vložiť link do tejto kolónky. Ak s tým potrebujete pomôcť, tu je </span>
                  <a href="https://support.google.com/youtube/answer/57407?hl=cs&co=GENIE.Platform%3DDesktop" target="_blank" rel="noopener noreferrer">stručný návod</a>.
                </p>
              </div>
            )}

            {type === 'Fotografie' && (
              <div className="fotky">
                <Uploader
                  fileList={this.props.imagesList}
                  onFileUploadStart={this.handleFileUploadStart}
                  onFinishedAllUploads={this.handleFilesUploadFinished}
                  onChange={this.props.onFilesChange(true)}
                  onFileSizeLimit={this.handleFileSizeLimit}
                  onFileRemove={this.handleFileRemove}
                  text={<span><em>Sem môžete priložiť vaše fotky</em></span>}
                />
                {isImageOverLimit && (
                  <p className="over-limit">
                    <span>Prekročili ste 10MB dátový limit ne jednu fotku, </span>
                    <span>jej veľkosť je {overLimitFileSize}MB. </span>
                    Prosím zmenšite ju a nahrajte znovu.
                  </p>
                )}
              </div>
            )}

            {type === 'Zvuk' && (
              <div className="audio">
                <Uploader
                  fileList={this.props.filesList}
                  onFileUploadStart={this.handleFileUploadStart}
                  onFinishedAllUploads={this.handleFilesUploadFinished}
                  onChange={this.props.onFilesChange(false)}
                  onFileSizeLimit={this.handleFileSizeLimit}
                  onFileRemove={this.handleFileRemove}
                  text={<span><em>Sem môžete priložiť vašu zvukovú nahrávku</em></span>}
                  isAudio
                />
                <p>Na jeden príspevok je povolená jedna nahrávka.<br />Odporúčaná dĺžka zvukového záznamu je do 10 minút.</p>
                {isAudioOverLimit && (
                  <p className="over-limit">
                    <span>Nahrávka prekročila 30MB dátový limit, </span>
                    <span>jej veľkosť je {overLimitFileSize}MB. </span>
                    Prosím zmenšite ju a nahrajte znovu.
                  </p>
                )}
              </div>
            )}
          </div>

          <Recaptcha
            ref={this.handleRecaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_PUBLIC}
            size="invisible"
            render="explicit"
            verifyCallback={this.handleRecaptchaResponse}
          />

          <Item className="gdpr-checkbox" prop="gdpr">
            <Checkbox checked={this.state.form.gdpr} onChange={this.handleChange('gdpr')}>
              <p>
                Týmto udeľujem svoj súhlas so spracúvaním svojich osobných údajov,
                <br />v rozsahu a za podmienok uvedených v<span>&nbsp;</span>
                <a href="/gdpr" target="_blank" rel="noopener noreferrer">Zásadách spracúvania osobných údajov</a>
                <span> s ktorými som sa pred udelením tohto súhlasu riadne oboznámil(a).</span>
              </p>
            </Checkbox>
          </Item>

          <Button
            type="primary"
            disabled={this.props.submitting || this.state.isUploading}
            onClick={this.handleSubmit}
          >{this.props.submitting ? 'Odosielam' : 'Odoslať'}
          </Button>
          {this.state.isUploading && (
            <p className="nahravame">Počkajte s odoslaním, nahrávame vaše súbory</p>
          )}

          {this.state.notValid && (
            <p className="check-form">Vo formulári sú asi nejaké chyby. Skúste ich opraviť :)</p>
          )}

          {this.props.hasSubmitErrored && (
            <div className="submit-has-errored">
              <p className="check-form">Nastala chyba pri odosielaní formulára. Informovali sme autorov. Prosím skúste to znova.</p>
              <p className="check-form">
                <Link to="/kontakt">Kontaktujte nás</Link> ak budú problémy pretrvávať. Ďakujeme za pochopenie.
              </p>
            </div>
          )}

        </Card>
      </Form>
    )
  }
}

UploadForm.propTypes = {
  filesList: PT.arrayOf(PT.shape({
    url: PT.string.isRequired,
    response: PT.string.isRequired,
  })),
  imagesList: PT.arrayOf(PT.shape({
    url: PT.string.isRequired,
    response: imagesProp.isRequired,
  })),
  onError: PT.func.isRequired,
  onFilesChange: PT.func.isRequired,
  onSubmitStart: PT.func.isRequired,
  onSubmit: PT.func.isRequired,
  submitting: PT.bool.isRequired,
  hasSubmitErrored: PT.bool.isRequired,
}

UploadForm.defaultProps = {
  filesList: [],
  imagesList: [],
}

export default UploadForm



// WEBPACK FOOTER //
// ./src/components/Form/Form.js